<template>
  <div>
    <div
      @click="toggle"
      class="flex items-center justify-start gap-[17px] cursor-pointer bg-white py-[16px] px-[24px] border-b"
    >
      <i
        :class="open ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
        class="transition-transform text-[#292D32] text-[16px]"
      ></i>
      <div>
        <h4
          class="text-[14px] text-text-[#353535] font-medium leading-[16.94px] mb-[8px]"
        >
          {{ title }}
        </h4>
        <p class="text-[14px] text-[#96A0B5] font-normal leading-[16.94px]">
          {{ description }}
        </p>
      </div>
    </div>
    <ul v-show="open">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="py-[25px] px-[65px] border-b border-t flex items-center gap-[50px]"
      >
        <p
          class="text-[14px] text-[#353535] font-medium leading-[16.94px] max-w-[300px] w-full"
        >
          {{ item.label }}
        </p>
        <span
          v-if="item.action"
          @click="viewItem(item)"
          class="text-[14px] text-[#96A0B5] font-medium leading-[20px] cursor-pointer"
          >View</span
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    items: Array,
    open: Boolean,
  },
  methods: {
    toggle() {
      this.$emit("toggle");
    },
    viewItem(item) {
      this.$emit("viewItem", item);
    },
  },
};
</script>
